import { useQuery, QueryHookOptions } from "@apollo/client";
import gql from "graphql-tag";

export const Tag = `
  tag
  type
  category
  meta
`;
export interface SummonerTag {
  tag: string;
  type: string;
  category: string;
  meta: string;
}

//-----------------------------------------------------------------------------------------------------------------

const GET_CHAMP_SELECT_TAGS = gql`
  query FetchChampSelectTags($summonerName: String!, $queueType: String!, $regionId: String!) {
    fetchChampSelectTags(queueType: $queueType, regionId: $regionId, summonerName: $summonerName) {
      champId
      tagList {
        ${Tag}
      }
    }
  }
`;

export interface FetchChampSelectTagsData {
  fetchChampSelectTags: Array<{
    champId: number;
    tagList: SummonerTag[];
  }>;
}

export function useChampSelectTags(
  summonerName: string,
  regionId: string,
  queueType: string,
  queryOptions: QueryHookOptions = {},
) {
  return useQuery<FetchChampSelectTagsData>(GET_CHAMP_SELECT_TAGS, {
    ...queryOptions,
    variables: {
      summonerName: decodeURIComponent(summonerName),
      regionId,
      queueType,
    },
  });
}

//-----------------------------------------------------------------------------------------------------------------

const LIVE_GAME_TAGS = gql`
  query LiveGameTags($queueId: Int!, $regionId: String!, $summoners: [LiveGameSummoner]!) {
    liveGameTags(queueId: $queueId, regionId: $regionId, summoners: $summoners) {
      summonerName
      tagList {
        ${Tag}
      }
    }
  }
`;

interface LiveGameTagsData {
  liveGameTags: Array<{
    summonerName: string;
    tagList: SummonerTag[];
  }>;
}

export const useLiveGameTags = (
  summoners: Array<{ summonerName: string; championId: number }>,
  regionId: string,
  queueId: number,
  queryOptions: QueryHookOptions = {},
) => {
  return useQuery<LiveGameTagsData>(LIVE_GAME_TAGS, {
    ...queryOptions,
    variables: {
      summoners,
      regionId,
      queueId,
    },
  });
};
